// Helpers para serializar tipos Mongo (Extended JSON)

export function oid(id) {
  if (!id) return null
  
  return { $oid: id }
}

export function date(value) {
  if (!value) return null

  if (value instanceof Date) {
    return { $date: value.toISOString() }
  }

  return { $date: new Date(value).toISOString() }
}

// Los ids guardados en localStorage pueden venir como Extended JSON ({ $oid }) o como string plano
export function idToString(id) {
  return (id?.$oid || id)?.toString() || null
}